/*
@license
  Expanse by Archetype Themes (https://archetypethemes.co)
  Access unminified JS in assets/theme.js

  Use this event listener to run your own JS outside of this file.
  Documentation - https://archetypethemes.co/blogs/expanse/javascript-events-for-developers

  document.addEventListener('page:loaded', function() {
    // Page has loaded and theme assets are ready
  });
*/

if (console && console.log) {
  console.log(
    "Expanse theme (" +
      theme.settings.themeVersion +
      ") Modded by realmwebdesign.com"
  );
}

(function () {
  "use strict";

  if (
    window.Shopify &&
    window.Shopify.theme &&
    navigator &&
    navigator.sendBeacon &&
    window.Shopify.designMode
  ) {
    navigator.sendBeacon(
      "https://api.archetypethemes.co/api/beacon",
      new URLSearchParams({
        shop: window.Shopify.shop,
        themeName:
          window.theme &&
          window.theme.settings &&
          `${window.theme.settings.themeName} v${window.theme.settings.themeVersion}`,
        role: window.Shopify.theme.role,
        route: window.location.pathname,
        themeId: window.Shopify.theme.id,
        themeStoreId: window.Shopify.theme.theme_store_id || 0,
        isThemeEditor: !!window.Shopify.designMode,
      })
    );
  }

  /*============================================================================
    Things that don't require DOM to be ready
  ==============================================================================*/

  /*============================================================================
    Things that require DOM to be ready
  ==============================================================================*/
  function DOMready(callback) {
    if (document.readyState != "loading") callback();
    else document.addEventListener("DOMContentLoaded", callback);
  }

  DOMready(function () {
    document.dispatchEvent(new CustomEvent("page:loaded"));
  });
})();


// ********** Shipping Fee JS ********** 
function shippingFee(item){
  $(item).parents('.shipping-question-items').removeClass('alert')
  if(item.value == 'yes' || item.value == 'Yes' || item.value == 'YES'){
    let varId = item.getAttribute('data-prod-id')
    let formData = {
      'items': [
        {
          'id': varId,
          'quantity': 1,
          'properties': {
          '_shippingFee': item.value
          }
        }
       ]
    };
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    }).then(response => {
      document.dispatchEvent(new CustomEvent('cart:build'));
      console.log("ADDED")
      return response.json();
    }).catch((error) => {
      console.error('Error:', error);
    });
  }else{
    fetch(window.Shopify.routes.root + 'cart.js')
      .then(response => response.json())
      .then(data => {
        const cartItems = data.items;
        let isAvailable = false;
        cartItems.forEach(item => {
          if (item.properties && item.properties._shippingFee === 'yes') {
            isAvailable = true;
          }
        });
      if (isAvailable) {
        let varId = item.getAttribute('data-prod-id');
        let formData = {
          'id': varId,
          'quantity': 0
        };
        fetch("/cart/change.js", {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
        }).then(response => {
          document.dispatchEvent(new CustomEvent('cart:build'));
          console.log("Removed")
          return response.json();
        }).catch((error) => {
          console.error('Error:', error);
        });
      }
    });
  }
}
function removeAllItems(){
  fetch(window.Shopify.routes.root + 'cart.js')
  .then(response => response.json())
  .then(data => {
    const cartItems = data.items;
    const isPresent = cartItems.some(item => {
      return item.variant_title === "55 Gallon Drum" || (item.variant_options && item.variant_options.includes("55 Gallon Drum"));
    });
    if (!isPresent) {
      let updates = {};
      let isAvailable = false;
      cartItems.forEach(item => {
        if (item.properties && item.properties._shippingFee === 'yes') {
          updates[item.variant_id] = 0;
          isAvailable = true;
        }
      });
      if(isAvailable){
        fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          	body: JSON.stringify({ updates })
        }).then(response => {
          document.dispatchEvent(new CustomEvent('cart:build'));
          console.log("Removed All")
          $.getJSON('/cart.js', function(cart){ 
              var result = cart.item_count;
              if(result == 0){
                window.location.reload();
              }
          });
          return response.json();
        }).catch((error) => {
          console.error('Error:', error);
        });

        $('.question-inputs input[value="yes"]').prop('checked', false);
        $('.question-inputs input[value="no"]').prop('checked', true);
        $('.shipping-question-main').hide()
      }
    } else {
     console.log("Is Present")
    }
  });
}
$(document).ready(function () {
  removeAllItems();
})